module.exports = __webpack_public_path__ + "img/icon_sas_darken.a45c139f.svg";